import { MoveEvent } from './MapObjectEvent'
import {
  Point,
  Vector,
  vectorFromPoints,
  vectorLength
} from '../../models/BasicTypes'

export default class MoveEventHelper {
  private readonly moveEvent: MoveEvent

  constructor (moveEvent: MoveEvent) {
    this.moveEvent = moveEvent
  }

  /**
   * duration of this move event in milliseconds
   */
  get duration () {
    return this.moveEvent.endsAt - this.moveEvent.createdAt
  }

  /**
   * vector of this move event
   */
  get vector (): Vector {
    return vectorFromPoints(this.moveEvent.source, this.moveEvent.destination)
  }

  /**
   * speed of this move event in map unit per milliseconds
   */
  get speed () {
    const vector = this.vector
    return vectorLength(vector) / this.duration
  }

  /**
   * speed of this move event in map unit per second
   */
  get speedPerSecond () {
    return this.speed / 1000
  }

  /**
   * get current position of this move event for given time
   * @param elasped elasped time in milliseconds for the current position
   * @param altSrc
   * @param altBeginTime
   */
  currentPosition (
    elasped: number,
    altSrc?: Point,
    altBeginTime?: number
  ): Point {
    const src = altSrc || this.moveEvent.source
    const beginTime = altBeginTime || this.moveEvent.createdAt
    const vector = vectorFromPoints(src, this.moveEvent.destination)
    const duration = this.moveEvent.endsAt - beginTime
    // the time is before move, just return the begin position
    if (elasped <= 0) {
      return src
    }
    // the move has finished already, just return the end position,
    // or the move duration is 0, just jump to the dest
    if (elasped >= duration || duration === 0) {
      return this.moveEvent.destination
    }
    const ratio = elasped / duration
    return {
      x: src.x + vector.dx * ratio,
      y: src.y + vector.dy * ratio
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/events/MoveEventHelper.ts